const keys = require('./keys')

const SEARCH = keys.default.search
const filterItemConfig = [
  // {
  //   name: '小组标引',
  //   key: 'group_index',
  //   chooseNum: 0,
  //   list: [],
  //   noticText: '',
  //   nextPage: false,
  //   isFav: true,
  //   isAnalysis: true // 分析时隐藏
  // },
  // {
  //   name: '个人标引',
  //   key: 'per_index',
  //   chooseNum: 0,
  //   list: [],
  //   noticText: '',
  //   nextPage: false,
  //   isAnalysis: true // 分析时隐藏
  // },
  // {
  //   name: '公共标引',
  //   key: 'pub_index',
  //   chooseNum: 0,
  //   list: [],
  //   noticText: '',
  //   nextPage: false,
  //   isAnalysis: true // 分析时隐藏
  // },
  {
    name: '专利类型',
    key: 'patent_type_cn_stat',
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '申请年', // 显示的名称
    oldKey: '申请年', // 旧版检索式拼接字段名
    key: SEARCH.applicationYear, // 请求数据时发给接口的字段名，false时取name值
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '公开年',
    oldKey: '公开年',
    key: SEARCH.publicYear,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: ['申请人(规)', '申请人(机构树)'],
    type: 'pae',
    currentIndex: 0,
    isTree: false,
    oldKey: ['applicants_normal_stat', '申请人(机构树)'],
    key: ['applicants_normal_stat', 'applicant_stand'],
    isSwitch: true,
    switchIcons: ['icon-leftalignment', 'icon-connections1-copy'],
    // key: SEARCH.pae,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true,
    tooltip: [
      '申请人(规)是专题库在原有数据基础上做的统一规范化处理，通过申请人名称标点符号格式、大小写缩写、全称、翻译方式、曾用名等多个维度，最终将确定为同一机构的名称统一整理为规范化名称，提高检索结果的检全率。',
      '申请人(机构树)是专题库在申请人规范化数据基础上做的标准化处理，标准化处理将100所国内高校及其下属院校、申请量排名前100家国内企业和申请量排名前100的国外企业的母公司及其子公司统一到一个机构名下，标引加工为申请人(机构树)，提高检索的全面性，方便用户查看和分析。'
    ]
  },
  /* {
    name: '申请人(标准化)',
    key: 'applicant_stand',
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  }, */
  {
    name: '发明人',
    oldKey: '发明人(精确)',
    key: SEARCH.ine,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: ['专利权人(规)', '专利权人(机构树)'],
    type: 'asg',
    currentIndex: 0,
    isTree: false,
    oldKey: ['assignees_normal_stat', '专利权人(机构树)'],
    key: ['assignees_normal_stat', 'assignees_stand'],
    isSwitch: true,
    switchIcons: ['icon-leftalignment', 'icon-connections1-copy'],
    // key: SEARCH.asg_s,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true,
    tooltip: [
      '专利权人(规)是专题库在原有数据基础上做的统一规范化处理，通过专利权人名称标点符号格式、大小写缩写、全称、翻译方式、曾用名等多个维度，最终将确定为同一机构的名称统一整理为规范化名称，提高检索结果的检全率。',
      '专利权人(机构树)是专题库在专利权人规范化数据基础上做的标准化处理，标准化处理将100所国内高校及其下属院校、申请量排名前100家国内企业和申请量排名前100的国外企业的母公司及其子公司统一到一个机构名下，标引加工为专利权人(机构树)，提高检索的全面性，方便用户查看和分析。'
    ]
  },
  /* {
    name: '主IPC分类号',
    oldKey: '主分类号',
    key: SEARCH.mic_s,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  }, */
  {
    name: 'IPC分类号',
    type: 'IPC', // 根据这类型展开时作特殊处理
    // oldKey: '主分类号',
    // key: SEARCH.mic_s,
    // oldKey: ['部', '大类', '小类', '大组', '小组'],
    // key: ['ipc_section_stat', 'ipc_mainclass_stat', 'ipc_subclass_stat', 'ipc_maingroup_stat', 'ipc_subgroup_stat'],
    isTabsGroup: true, // 属于内嵌tabs的类型
    isSwitch: true,
    isV2percent: true, // 属于切换值为百分比
    v2percentIndex: [1], // 值转为百分比的icon下标
    switchIcons: ['icon-N', 'icon-percent'],
    componentGroup: 'IpcGroup',
    labelPrefix: 'ipc',
    tabsList: [ // ipc 的tabsList
      { label: '部', value: 'ipc_section_stat' },
      { label: '大类', value: 'ipc_mainclass_stat' },
      { label: '小类', value: 'ipc_subclass_stat' },
      { label: '大组', value: 'ipc_maingroup_stat' },
      { label: '小组', value: 'ipc_subgroup_stat' }
    ],
    key: 'ipc_section_stat',
    total: 0,
    currentIndex: 0,
    isNumber: false, // 显示数字还是百分比
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '公开国',
    key: SEARCH.pcname,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '申请人类型(中国)',
    oldKey: '申请人类型',
    key: SEARCH.pat_s,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '专利状态',
    key: SEARCH.psc_s,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '最新法律状态',
    oldKey: '最新法律状态',
    key: SEARCH.lsc_s,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '运营状态',
    key: 'legal_status',
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '转让年',
    key: 'legal_transfered_year',
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '许可年',
    key: 'legal_licensed_year',
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '质押年',
    key: 'legal_pledged_year',
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '失效年',
    key: 'expired_year',
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '权利要求数',
    key: 'claims_num',
    value: [0, 6],
    controlType: 'slider',
    componentGroup: 'SliderGroup',
    disabled: false,
    defaultValue: [0, 6]
  },
  {
    name: '代理人',
    oldKey: '代理人(精确)',
    key: SEARCH.ate,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '专利代理机构',
    oldKey: '代理机构(精确)',
    key: SEARCH.agce,
    chooseNum: 0,
    list: [],
    noticText: '',
    pageSize: 1,
    nextPage: true
  },
  {
    name: '引用数量',
    key: 'citation_count',
    value: [0, 6],
    controlType: 'slider',
    componentGroup: 'SliderGroup',
    disabled: false,
    defaultValue: [0, 6]
  },
  {
    name: '被引用数量',
    key: 'cited_count',
    value: [0, 6],
    controlType: 'slider',
    componentGroup: 'SliderGroup',
    disabled: false,
    defaultValue: [0, 6]
  }
]
// 添加默认的配置
filterItemConfig.forEach((item) => {
  item.open = false // 下拉开关
  item.hasRequest = false // 是否已经请求过数据
  item.page = 1 // 默认内容分页为第一页
  item.pageSize = 20 // 默认一页20条
})

module.exports = {
  filterItemConfig
}